/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 
import { BaseAction } from '../../types/base-action.type';
import * as actions from '../../types/ui-action.type';

export type UiState = {
  theme: string,
  isSetting: boolean,
  error?: any,
};

const initialState: UiState = {
  theme: '',
  isSetting: false
}

export const uiReducer = (
  state: UiState = initialState,
  action: BaseAction
) => {
  switch (action.type) {
    case actions.SET_UI_THEME:
      return {...state, isSetting: true, error: null}
    case actions.SET_UI_THEME_SUCCESS:
      return {...state, theme: action.payload, error: null, isSetting: false}
    case actions.SET_UI_THEME_FAILURE:
      return {...state, error: action.payload, isSetting: false}
    default:
      return state;
  }
};
